exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resources-container[data-v-04ff7217]{background:#f6f6f6;height:150px;padding:10px 10px 10px 20px;width:100%}.related-resources-title[data-v-04ff7217]{font-size:18px;color:#2f3642}", ""]);

// exports
